import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import MenuFind from '../../components/MenuFind';
import FooterForm from '../../components/FooterForm';

function NoRoute({ page }) {
  return (
    <PageWrapper>
      <PageHelmet page={page} />
      <InsideHeader
        h1={`${page.page_title[0].title}`}
        h1Pre={`${page.page_title[0].pretitle}`}
        leadText={`${page.lead_copy}`}
      />
      <MenuFind />
      <FooterForm />
    </PageWrapper>
  );
}

NoRoute.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'page_not_found',
})(NoRoute);



// WEBPACK FOOTER //
// ./src/pages/NoRoute/index.js